import React from 'react'
import { Box, Button, TextField } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import RotateLeftIcon from '@mui/icons-material/RotateLeftOutlined'

interface SlimSearchBarProps {
  textFieldValue: string
  onChangeTextField: (text: string) => void
  onSearch: () => void
  onResetSearch: () => void
  buttonTitle: string
}

export const SlimSearchBar: React.FC<SlimSearchBarProps> = ({
  onSearch,
  onChangeTextField,
  onResetSearch,
  textFieldValue
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <TextField
        variant='outlined'
        placeholder='Escribe aquí'
        onChange={(e) => onChangeTextField(e.target.value)}
        value={textFieldValue}
        sx={{
          flexGrow: 1,
          '& .MuiOutlinedInput-root': {
            borderRadius: '50px 0 0 50px',
            height: '56px'
          }
        }}
      />
      <Button
        variant='contained'
        color='primary'
        onClick={onSearch}
        sx={{
          borderRadius: 0,
          height: '100%',
          minHeight: '56px'
        }}
      >
        <SearchIcon />
      </Button>
      <Button
        variant='contained'
        onClick={onResetSearch}
        sx={{
          borderRadius: '0 50px 50px 0',
          height: '100%',
          minHeight: '56px'
        }}
      >
        <RotateLeftIcon />
      </Button>
    </Box>
  )
}

export default SlimSearchBar
